module.exports = function getResource(label, vars = []) {
    let resources = {
        buyWith: 'Buy with'
    };

    return resources[label];
};
